import React from 'react'
import withIcon from '@/components/withIcon'
const IconLink = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons/Bootstrap/Keyboard/16px/Link-45deg">
        <g id="Vector">
          <path
            d="M4.71491 6.54257L3.34315 7.91432C2.17158 9.0859 2.17158 10.9854 3.34315 12.157C4.51473 13.3285 6.41422 13.3285 7.58579 12.157L9.41422 10.3285C10.5858 9.15697 10.5858 7.25747 9.41422 6.0859C9.16628 5.83796 8.88575 5.64249 8.58641 5.4995L8.00001 6.0859C7.93903 6.14688 7.88757 6.21377 7.84564 6.28473C8.16107 6.37512 8.45865 6.54454 8.70711 6.793C9.48816 7.57405 9.48816 8.84038 8.70711 9.62143L6.87869 11.4499C6.09764 12.2309 4.83131 12.2309 4.05026 11.4499C3.26921 10.6688 3.26921 9.40248 4.05026 8.62143L4.84286 7.82883C4.73067 7.4087 4.68802 6.97387 4.71491 6.54257Z"
            fill="#162941"
          />
          <path
            d="M5.71173 6.95996L5.87869 6.793C6.13628 6.53541 6.44665 6.36278 6.77499 6.2751C6.86267 5.94675 7.03531 5.63638 7.2929 5.37879L7.45985 5.21184C6.96199 5.18426 6.45857 5.28015 5.99939 5.4995C5.78004 5.95868 5.68415 6.4621 5.71173 6.95996Z"
            fill="#162941"
          />
          <path
            d="M6.58579 4.67168C5.41422 5.84326 5.41422 7.74275 6.58579 8.91432C6.83373 9.16226 7.11427 9.35773 7.41361 9.50072L8.1892 8.72513C7.86086 8.63744 7.55049 8.46481 7.2929 8.20722C6.51185 7.42617 6.51185 6.15984 7.2929 5.37879L9.12133 3.55036C9.90238 2.76931 11.1687 2.76931 11.9498 3.55036C12.7308 4.33141 12.7308 5.59774 11.9498 6.37879L11.1571 7.1714C11.2693 7.59152 11.312 8.02635 11.2851 8.45766L12.6569 7.0859C13.8284 5.91432 13.8284 4.01483 12.6569 2.84326C11.4853 1.67168 9.58579 1.67168 8.41422 2.84326L6.58579 4.67168Z"
            fill="#162941"
          />
          <path
            d="M10.0006 9.50072C10.22 9.04155 10.3159 8.53812 10.2883 8.04026L10.1213 8.20722C9.86374 8.46481 9.55336 8.63744 9.22502 8.72513C9.13734 9.05347 8.9647 9.36384 8.70711 9.62143L8.54016 9.78838C9.03802 9.81596 9.54144 9.72008 10.0006 9.50072Z"
            fill="#162941"
          />
        </g>
      </g>
    </svg>
  )
}
export default withIcon(IconLink)
